import React from 'react';
import Item from './Item';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object
    },
    getInitialState() {
        return {
            loading: true,
            error: false,
            data: []
        };
    },
    componentWillMount() {
        this.serverRequest = $.get(this.props.urls.get, (result) => {
            this.setState({
                loading: false,
                data: result
            });
        }).fail((jqXHR, textStatus, errorThrown ) => {
            console.log(errorThrown);
            this.setState({
                loading: false,
                error: true
            });
        });
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
    },
    render() {
        if (this.state.data.length) {
            return (
                <div className="c-clubnews">
                    <div className="c-clubnews__header">{this.props.i18n.title}</div>
                    {this.state.data.map((model) => {
                        return <Item
                            key={model.Id}
                            title={model.Title}
                            date={model.Date}
                            detailsUrl={model.DetailsUrl}
                        />
                    })}
                </div>
            );
        } else {
            return false;
        }
    }
});
